import React, {Component} from 'react'

import nextId from 'react-id-generator'
import {v1 as uuidv1} from 'uuid'

import ResultSlider from './ResultSlider/ResultSlider'
import ResultReviews from './ResultReviews/ResultReviews'
import ResultRating from './ResultRating/ResultRating'
import ResultPros from './ResultPros/ResultPros'
import ResultRatingList from './ResultRatingList/ResultRatingList'
import ResultTimer from './ResultTimer/ResultTimer'

import style from './resultPage.module.scss'


class ResultPage extends Component {
   state = {
      final: null,
   }
   htmlId = nextId()
   resultSliderSettings = {
      autoplay: false,
      infinite: true,
      slidesToShow: this.props.final.images && (this.props.final.images.length - 0.9),
      pauseOnFocus: true,
      pauseOnHover: true,
      responsive: [
         {
            breakpoint: 700,
            settings: {
               slidesToShow: this.props.final.images && (this.props.final.images.length - 1.2),
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 1139,
            settings: {
               slidesToShow: this.props.final.images && this.props.final.images.length - 1,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 1440,
            settings: {
               slidesToShow: this.props.final.images && (this.props.final.images.length - 0.5),
               slidesToScroll: 2,
            },
         },
         {
            breakpoint: 8000,
            settings: {
               slidesToShow: this.props.final.images && (this.props.final.images.length - 0.5),
               slidesToScroll: 2,
            },
         },
      ],
   }
   resultReviewSliderSettings = {
      autoplay: false,
      infinite: true,
      slidesToShow: 1,
      pauseOnFocus: true,
      pauseOnHover: true,
      adaptiveHeight: true,
      dots: true,
   }

   componentDidMount() {
      const {final} = this.props
      this.setState({final: final})
   }

   render() {
      const rootBlock = document.querySelector('#quizContainer')
      const rootBody = document.querySelector('body')
      rootBlock.style.background = '#FDC54F'
      rootBody.style.background = '#FDC54F'
      const {final} = this.state
      return (
         <>
            {final &&
            <div className={style.resultPage}>
               <h1 className={style.resultPage__title}>Congratulations</h1>
               <p className={style.resultPage__subtitle}>Based on your answers we found a site where you can find a
                  woman
                  of your dreams</p>
               <div className={style.resultPage__block} key={uuidv1()}>
                  <span className={style.resultPage__blockTitle}>Find your wife</span>
                  <div className={style.resultPage__ratingBlock}>
                     {
                        !!final.logo
                           ? (
                              <img className={style.resultPage__logoImg} src={final.logo} alt={final.title} width='100' />)
                           : <div className={style.resultPage__emptyLogoImg}></div>
                     }
                     <ResultRating rating={final.rating} />
                     <ResultRatingList data={final} />
                  </div>
                  <div className={style.resultPage__photoContainer}>
                     <div className={style.resultPage__photoBlock} onPointerMove={this.scrollImg}>
                        <p className={style.resultPage__photoTitle}>Girls online on <a
                           className={style.resultPage__linkReview} href={final.link_review}> {final.title}</a></p>
                        <ResultSlider settings={this.resultSliderSettings} images={final.images} />
                     </div>
                     <ResultPros pros={final.pros} />
                  </div>
                  <div className={style.resultPage__goToSiteBlock}>
                     <p className={style.resultPage__goToSiteTitle}>Congratulations! <br />You’re qualified to
                        access <span> </span>
                        <a className={style.resultPage__linkReview} href={final.link_review}>{final.title}</a>
                     </p>
                     <span
                        className={style.resultPage__goToSiteSubtitle}>Your registration slot will be active only</span>
                     <ResultTimer />
                     <a className={style.resultPage__goToSiteLink} href={final.link_offer}>
                        <span className={style.resultPage__goToSiteBtn}>GO TO SITE</span>
                        <span className={style.resultPage__visitSiteBtn}>visit site
                        <svg className={style.resultPage__visitSiteArrow} width='7' height='10' viewBox='0 0 7 10'
                             fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path opacity='0.5' d='M1 9L5 5L1 1' stroke='white' strokeWidth='2' />
                        </svg>
                    </span>
                     </a>
                  </div>
               </div>
               <ResultReviews settings={this.resultReviewSliderSettings} reviews={final.success_story} />
            </div>}
         </>
      )
   }
}

export default ResultPage